import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export function SiTaxReports(props: IconProps): React.ReactElement {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14.5 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14.5 17h-6m8-4h-8m12-3.012V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.22 22 17.38 22 15.7 22H9.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4.5 19.72 4.5 18.88 4.5 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.78 2 7.62 2 9.3 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
      />
    </Icon>
  );
}
